module.exports = __webpack_public_path__ + "img/laos.125b45f7.jpg";